// =============================================================================
// walk-per-stop.ts – Stop-specific walking times configuration and lookup
// =============================================================================

import type { AppState, AppConfig } from "./types.js";

// Walk times for Busto Garolfo stops
export const BT_WALK_TIMES: Record<string, number> = {
  BT703: 2, // Via Buonarroti 3
  BT947: 2, // Via Buonarroti 3 (lato ritorno)
  BT949: 4, // Piscina 91
  BT951: 4, // Piscina 90
  BT999: 5, // Deposito
  BT956: 8, // Via Montebianco 17
  BT205: 6, // V.B.A. fr.48
  BT775: 10, // Via Rossini 35
  BT301: 3 // Via Buonarroti ang. V. Busto A.
};

/**
 * Gets the walk time to the given stop.
 * Resolves stop-specific walk times for the active focus city,
 * falling back to state.settings.walkRossini, and then cfg.defaults.walkRossini.
 */
export function getWalkMinForStop(stopCode: string, state: AppState, cfg: AppConfig): number {
  const focusCity = state?.settings?.focusCity || cfg?.defaults?.focusCity || "BT";

  // Only Busto Garolfo ("BT") has specific walk times in this phase
  if (focusCity === "BT" && stopCode in BT_WALK_TIMES) {
    return BT_WALK_TIMES[stopCode];
  }

  // Also check if the config has custom walkTimes under focusCities config
  const cityConfig = cfg?.focusCities?.[focusCity];
  const customWalkTimes = (cityConfig as any)?.walkTimes;
  if (customWalkTimes && stopCode in customWalkTimes) {
    return Number(customWalkTimes[stopCode]);
  }

  // Fallback to user custom global walk time or default fallback
  const fallbackWalk = state?.settings?.walkRossini ?? cfg?.defaults?.walkRossini ?? 6;
  return Number(fallbackWalk);
}

/**
 * Returns default walk times dictionary for a focus city.
 */
export function getDefaultWalkTimes(focusCity: string, cfg: AppConfig): Record<string, number> {
  if (focusCity === "BT") {
    return BT_WALK_TIMES;
  }
  const cityConfig = cfg?.focusCities?.[focusCity];
  return (cityConfig as any)?.walkTimes || {};
}
